{
  "genders": {
    "ascsg-code.male": "Male",
    "ascsg-code.female": "Female",
    "ascsg-code.other": "Other"
  }
}
